
import api from 'api/api'
import { toast } from 'react-toastify'

export const SAVE_STORE_LOCATION = '[STORE_LOCATIONS] SAVE STORE LOCATION'
export const DELETE_STORE_LOCATION = '[STORE_LOCATIONS] DELETE STORE LOCATION'

export function saveStoreLocation(form) {
  const request = api.post(`/store-location/save`, form)
  return (dispatch) => {
    dispatch({ type: SAVE_STORE_LOCATION, payload: { saving: true } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({
        type: SAVE_STORE_LOCATION,
        payload: { saved: true, data: response.data.data }
      })
      // toast.success(response.data.message)
    }).catch((error) => {
      toast.error("Error inesperado, no se pudo guardar la ubicación")
      // console.log(SAVE_STORE_LOCATION, error)
    }).finally(() => {
      dispatch({ type: SAVE_STORE_LOCATION, payload: { saving: false } })
    })
  }
}

export function deleteStoreLocation(ubicacion_almacen_id, almacen_id) {
  const request = api.post(`/store-location/delete`, { ubicacion_almacen_id })
  return (dispatch) => {
    dispatch({ type: DELETE_STORE_LOCATION, payload: { deleting: true, id: ubicacion_almacen_id } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({
        type: DELETE_STORE_LOCATION,
        payload: { deleted: true, id: ubicacion_almacen_id, almacen_id: almacen_id }
      })
      // toast.success(response.data.message)
    }).catch((error) => {
      toast.error("Error inesperado, no se pudo eliminar la ubicación")
      // console.log(DELETE_STORE_LOCATION, error)
    }).finally(() => {
      dispatch({ type: DELETE_STORE_LOCATION, payload: { deleting: false, id: ubicacion_almacen_id } })
    })
  }
}
